import { useSelector } from 'react-redux';

import {
  pageNameSelector,
  pageTypeSelector,
} from '@/domains/core/page/page.selectors';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { useNbRefinedFacets } from '@/domains/productDiscovery/Listings/facets/hooks/useNbRefinedFacets';
import { useCurrentPage } from '@/domains/productDiscovery/Listings/hooks/useCurrentPage';

import { useElementRef } from './useElementRef';

export interface B2BTouchpointProps {
  classNames?: string;
}

export const useB2BTouchpoint = (isTopBanner: boolean) => {
  const { elementRef, hasBeenDisplayed } = useElementRef();

  /*TODO: this was a call to 'useFeatureFlags' replaced with the value of the flag/abtest. Consider removing this call when you modify the file.*/
  const [ffB2bTouchpointListingPage] = [true];
  const currentPage = useCurrentPage();
  const nbAppliedFilters = useNbRefinedFacets();
  const isFirstPage = currentPage === 1 && nbAppliedFilters === 0;
  const pageType = useSelector(pageTypeSelector);
  const pageName = useSelector(pageNameSelector);

  const onDisplay = () => {
    Gtm.push({
      event: 'interaction_display_campaign',
      e_category: 'ecommerce',
      e_action: 'Display campaign',
      event_trigger: 'listing-pages-pro-touchpoint',
      e_label: 'listing-pages-pro-touchpoint',
      amp_event_name: 'Display campaign',
      campaign_name: 'listing-pages-pro-touchpoint',
      campaign_id: undefined,
      campaign_market: 'b2c',
      space_slug: isTopBanner ? 'top_banner' : 'bottom_banner',
      page_name: pageName,
      page_type: pageType,
    });
  };

  const onClick = () => {
    Gtm.push({
      amp_event_name: 'Click on login b2b',
      e_action: 'Click on login b2b',
      e_category: 'navigation',
      e_label: isTopBanner
        ? 'listing-pages-pro-touchpoint-top'
        : 'listing-pages-pro-touchpoint-bottom',
      event: 'interaction_click on login b2b',
      event_trigger: isTopBanner
        ? 'listing-pages-pro-touchpoint-top'
        : 'listing-pages-pro-touchpoint-bottom',
      page_name: pageName,
      page_type: pageType,
    });
  };

  return {
    ffB2bTouchpointListingPage,
    onDisplay,
    onClick,
    pageType,
    pageName,
    elementRef,
    hasBeenDisplayed,
    isFirstPage,
  };
};
